export type userRoleState = {
    roleList: RoleList[] | null;
};

export type RoleList = {
    role_id: number;
    role: Role;
};

export type Role = "admin" | "school" | "kerbside" | "government";

export type Status = 0 | 1;

export const userRoleList: userRoleState = {
    roleList: null,
};
